import axios, {AxiosRequestConfig} from 'axios'
import {baseUrl, tokenKey} from './SERVICE-CONSTANTS'
import {getItem, removeItem, setItem} from '../utils/localstorage'
const axiosInstance = axios.create()

axiosInstance.defaults.baseURL = baseUrl;

const setToken = (tokenKey: any, token: any) => {
  setItem(tokenKey, token)
}

const getToken = (tokenKey: any) => {
  return getItem(tokenKey)
}

const removeToken = (tokenKey: any) => {
  removeItem(tokenKey)
}

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    try {
      const expectedError =
        error.response && error.response.status >= 400 && error.response.status < 500

      if (expectedError) {
        if (error.response.status === 401) {
          removeItem(tokenKey)
          if (window.location.pathname !== '/auth') window.location.href = '/auth'
        }
      }
    } catch (error) {}
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    if (!config.headers) config.headers = {}

    // Now config.headers can be safely used
    config.headers.Authorization = 'bearer ' + getItem(tokenKey)

    return config
  },
  (error) => error
)

const http = {
  post: axiosInstance.post,
  put: axiosInstance.put,
  delete: axiosInstance.delete,
  get: axiosInstance.get,
  setToken,
  getToken,
  removeToken,
  tokenKey,
}

export default http
